module.exports = __webpack_public_path__ + "static/media/html.3db31354.svg";